import { forwardRef, memo } from 'react';

import { cn } from '../../lib/styles';
import { PageHeaderTitle } from './PageHeaderTitle';

export interface PageHeaderFlexProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  titleClassName?: string;
  titleSuffix?: React.ReactNode;
  left?: React.ReactNode;
  right?: React.ReactNode;
}

const PageHeaderFlexBase = (
  { title, titleClassName, titleSuffix, subTitle, className, left, right, ...rest }: PageHeaderFlexProps,
  ref: React.ForwardedRef<HTMLDivElement>,
) => {
  return (
    <div ref={ref} className={cn('flex items-center gap-x-4 gap-y-2 px-6 py-4', className)} {...rest}>
      {left && <div className="shrink-0">{left}</div>}

      <div className="flex-1" data-slot="title">
        <PageHeaderTitle className={titleClassName} suffix={titleSuffix} subTitle={subTitle}>
          {title}
        </PageHeaderTitle>
      </div>

      {right && <div className="shrink-0">{right}</div>}
    </div>
  );
};

export const PageHeaderFlex = memo(forwardRef(PageHeaderFlexBase));
